import { gql } from '@apollo/client';

const LOGIN_UPERCUT_PAYLOAD = `
    token
    tokenExpiration
`;

const LOGIN_ACCOUNT_PAYLOAD = `
    token
    tokenExpiration
    userId
    role
    email
    status
    active
    fullName
    photo
    logo
    professions
    specialties
    commercialName
    name
    bossFirstname
    bossLastname
    onboardingCompleteDate
    acceptTnc
    changePassword
`;

export const loginUpercutQuery = gql`
  query LoginUpercut($email: String!, $password: String!) {
    loginUpercut(email: $email, password: $password) {
      ${LOGIN_UPERCUT_PAYLOAD}
    }
  }
`;

export const loginAccountQuery = gql`
  query LoginAccount($email: String!, $password: String!) {
    loginAccount(email: $email, password: $password) {
      ${LOGIN_ACCOUNT_PAYLOAD}
    }
  }
`;

/**
 * Password Reset Mutations (Phase 4: User Story 2)
 */

// Mutation to request password reset code via email
export const UPDATE_PASSWORD_FORGOT_BY_EMAIL = gql`
  mutation UpdatePasswordForgotByEmail($email: String!) {
    updatePasswordForgotByEmail(email: $email) {
      status
      message
    }
  }
`;

// Mutation to reset password with code and auto-login
export const UPDATE_PASSWORD_FORGOT = gql`
  mutation UpdatePasswordForgot($resetPasswordInput: InputResetPasswordCode!) {
    updatePasswordForgot(resetPasswordInput: $resetPasswordInput) {
      ${LOGIN_ACCOUNT_PAYLOAD}
    }
  }
`;

// Mutation to resend password reset code
export const RESEND_RESET_PASSWORD_CODE = gql`
  mutation ResendResetPasswordCode($email: String!) {
    resendResetPasswordCode(email: $email) {
      status
      message
    }
  }
`;
